import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';
import type { ClaimCampaignRequest } from '@bvengineering/cas-member-gateway-service-client';

type Request = { campaignId: number; request: ClaimCampaignRequest };

/**
 * Hook to claim a campaign using Member Gateway SDK
 */
export function useClaimCampaign() {
  const queryClient = useQueryClient();

  return useApiMutation<void, AxiosError, Request>({
    mutationFn:
      (api) =>
      async ({ campaignId, request }) => {
        await api.campaigns.campaignsControllerClaimCampaign(campaignId, request);
      },
    onSuccess: async (_data, { campaignId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) }),
        queryClient.invalidateQueries({ queryKey: campaignKeys.lists() }),
      ]);
    },
  });
}
